import { Icon } from "leaflet";

export const bMarker = new Icon({
  iconUrl: require("../assets/icons8_marker_48px.png"),
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
});

export const rMarker = new Icon({
  iconUrl: require("../assets/icons8_marker_48px_1.png"),
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41],
});

export const gMarker = new Icon({
  iconUrl: require("../assets/icons8_marker_48px_2.png"),
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
});

export const oMarker = new Icon({
  iconUrl: require("../assets/marker-icon-orange.png"),
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
});
